import { UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth-context";
import { useAvisosNovoCorretor, useMarcarAvisoVisto } from "@/hooks/use-mercado";

/**
 * "Fulano criou acesso e agora acompanha suas cargas."
 *
 * ⚠️ Não é enfeite: é o CONTROLE COMPENSATÓRIO do claim-by-token. O token prova posse
 * do link, não do número — quem receber o link encaminhado poderia criar a conta. O
 * produtor é quem tem o telefone do corretor de verdade e reconhece (ou estranha) o
 * nome. Por isso o card é explícito e só some quando ele confirma que viu.
 *
 * Renderiza nada quando não há aviso — pode ser montado em qualquer tela do produtor.
 */
export function AvisoNovoComprador() {
  const { user } = useAuth();
  const ehProdutor = user?.orgTipo !== "COMPRADOR";
  const temMercado = (user?.modulesEnabled ?? []).includes("mercado");
  const { data: avisos } = useAvisosNovoCorretor(ehProdutor && temMercado);
  const marcarVisto = useMarcarAvisoVisto();

  if (!avisos || avisos.length === 0) return null;

  return (
    <div className="flex flex-col gap-2">
      {avisos.map(a => (
        <div
          key={a.vinculoId}
          className="rounded-xl border border-sucesso/30 bg-sucesso-suave p-4 flex flex-col gap-3"
          data-testid={`aviso-corretor-${a.vinculoId}`}
        >
          <div className="flex items-start gap-3">
            <UserPlus className="h-5 w-5 text-sucesso shrink-0 mt-0.5" />
            <div>
              <p className="font-bold text-sm">
                {a.compradorNome} criou acesso e agora acompanha suas cargas.
              </p>
              <p className="text-xs text-muted-foreground mt-0.5">
                {a.romaneios === 1
                  ? "1 romaneio seu já está na conta dele."
                  : `${a.romaneios} romaneios seus já estão na conta dele.`}
                {" "}Não reconhece esse nome? Fale com ele antes de formalizar a próxima carga.
              </p>
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            className="w-fit"
            onClick={() => marcarVisto.mutate(a.vinculoId)}
            disabled={marcarVisto.isPending}
            data-testid={`aviso-ok-${a.vinculoId}`}
          >
            Ok, entendi
          </Button>
        </div>
      ))}
    </div>
  );
}
